import { IPreCasInterview } from '../../../types';
export type PreCasInterviewState = IPreCasInterview

export enum PreCasInterviewTypes {
  UPDATE_PCI_FIELD = '@@visa/preCasInterview/UPDATE_PCI_FIELD'
}

export enum Pages {
  PAGE1 = 'student-pc-step1',
  PAGE2 = 'student-pc-step2',
  PAGE3 = 'student-pc-step3',
  PAGE4 = 'student-pc-step4'
}
